"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Journey() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const reassurances = ["Initial Consultation", "DDS Eligibility Review", "Personalized Care Plan"];
  return <section data-section-id="317" id="start-your-journey" className="bg-background text-foreground relative overflow-hidden rounded-t-[3rem] px-6 py-24 md:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-32 -right-32 h-[28rem] w-[28rem] rounded-lg opacity-40 blur-3xl" style={{
      background: "hsl(195 100% 40%)"
    }} />

      {}
      <svg aria-hidden="true" className="pointer-events-none absolute top-10 left-8 h-16 w-16 opacity-70 md:top-14 md:left-14 md:h-20 md:w-20" viewBox="0 0 80 80" fill="none" stroke="hsl(195 100% 40%)" strokeWidth="2" strokeLinecap="round">
        <circle cx="40" cy="40" r="14" />
        <line x1="40" y1="8" x2="40" y2="18" />
        <line x1="40" y1="62" x2="40" y2="72" />
        <line x1="8" y1="40" x2="18" y2="40" />
        <line x1="62" y1="40" x2="72" y2="40" />
        <line x1="17" y1="17" x2="24" y2="24" />
        <line x1="56" y1="56" x2="63" y2="63" />
        <line x1="63" y1="17" x2="56" y2="24" />
        <line x1="24" y1="56" x2="17" y2="63" />
      </svg>

      <div ref={ref} className={`relative z-10 mx-auto flex max-w-[720px] flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
        {}
        <div className="mb-8 inline-block -rotate-[4deg] rounded-lg px-4 py-1.5 text-xs font-semibold tracking-[0.18em] shadow-md" style={{
        backgroundColor: "hsl(195 100% 40%)",
        color: "hsl(210 20% 98%)"
      }}>
          DDS QUALIFIED PROVIDER
        </div>

        {}
        <h2 className="font-serif font-default text-5xl leading-[1.05] tracking-tight text-foreground sm:text-6xl md:text-7xl">
          Begin your{" "}
          <em className="font-serif italic" style={{
          color: "hsl(195 100% 40%)"
        }}>
            support journey
          </em>
        </h2>

        {}
        <svg aria-hidden="true" className="mt-6 h-5 w-40" viewBox="0 0 160 20" fill="none" stroke="hsl(195 100% 40%)" strokeWidth="2.5" strokeLinecap="round">
          <path d="M4 12 Q 20 2, 36 12 T 68 12 T 100 12 T 132 12 T 156 12" />
        </svg>

        {}
        <p className="mt-8 max-w-xl leading-relaxed text-foreground/70 !text-base !font-serif !text-center">About Waters Well Inc.<br />&nbsp;Waters Well Inc. is a Connecticut DDS-qualified provider supporting individuals with intellectual and developmental disabilities and their families. Guided by transparency, clinical excellence, and respect, we help every Community Member live with dignity and independence.<br />Our Services<br />Day Program: A structured, engaging setting where Community Members build life skills, pursue their interests, and connect with their community.<br />&nbsp;In-Home Supports: Personalized help at home with daily living skills, routines, and independence.<br />Transportation: Safe, reliable rides to programs, appointments, and community activities. Companionship: Friendly, consistent support for social outings, hobbies, and everyday connection.<br />Respite: Short-term care that gives families time to rest and recharge, knowing their loved one is in good hands.<br />And More: Every plan is built around the individual. Ask us about additional services to fit your needs.<br />Let's Talk! Contact us to learn how we can help you or your loved one thrive."</p>

        {}
        <div className="mt-10 flex w-full flex-col items-stretch justify-center gap-4 sm:flex-row sm:items-center">
          <Button asChild size="lg" className="h-16 rounded-lg px-8 text-base font-semibold shadow-lg transition-transform hover:-translate-y-0.5 hover:shadow-xl" style={{
          backgroundColor: "hsl(195 100% 40%)",
          color: "hsl(210 20% 98%)"
        }}>
            <Link to="/GetInTouchPage" className="flex items-center justify-center">
              Request Services
              <ArrowRight className="ml-1 size-5" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="h-16 rounded-lg border-2 border-foreground/40 bg-transparent px-8 text-base font-semibold text-foreground hover:bg-foreground/10 hover:text-foreground">
            <Link to="tel:+18605550123" className="flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone size-5" aria-hidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>Call (475) 219-1020</Link>
          </Button>
        </div>

        {}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-2 gap-y-2 text-sm text-foreground/65 md:text-base">
          {reassurances.map((item, i) => <div data-index={i} key={item} className="flex items-center gap-2">
              <span className="flex items-center gap-1.5">
                <span style={{
              color: "hsl(195 100% 40%)"
            }}></span>
                {item}
              </span>
              {i < reassurances.length - 1 && <span aria-hidden="true" className="mx-1 inline-block h-1 w-1 rounded-lg bg-foreground/30" />}
            </div>)}
        </div>
      </div>
    </section>;
}